<template>
  <b-nav-item
    class="item"
    @click="exec"
  >
    <font-awesome-icon
      class="icon"
      :icon="icon"
      size="lg"
    />
    {{ title }}
  </b-nav-item>
</template>

<script>
export default {
  props: {
    icon: {
      type: String
    },

    title: {
      type: String
    },

    action: {
      type: Function
    },

    goTo: {
      type: Function
    }
  },

  methods: {
    exec () {
      if (this.action) this.action()
      if (this.goTo) this.goTo()
    }
  }
}
</script>


<style lang="scss" scoped>
.item {
  font-size: 0.8rem;
}

.icon {
  margin-left: 8px;
  margin-right: 8px;
}
</style>
